
<div class="rend-wrapper" *ngIf="modelo && isshow">
  <div class="rend-range-btns">
    <button (click)="setRange('container','1M')">1M</button>
    <button (click)="setRange('container','3M')">3M</button>
    <button (click)="setRange('container','6M')">6M</button>
    <button (click)="setRange('container','1Y')">1A</button>
    <button (click)="setRange('container','all')">Todo</button>
  </div>
  <div id="container" class="rend-chart"></div>
</div>

<div class="rend-wrapper" *ngIf="isPlanificador && divIsShow">
  <div class="rend-range-btns">
    <button (click)="setRange('container2','1M')">1M</button>
    <button (click)="setRange('container2','3M')">3M</button>
    <button (click)="setRange('container2','6M')">6M</button>
    <button (click)="setRange('container2','1Y')">1A</button>
    <button (click)="setRange('container2','all')">Todo</button>
  </div>
  <div id="container2" class="rend-chart"></div>
</div>

<div class="rend-wrapper" *ngIf="isGestion">
  <div class="rend-range-btns">
    <button (click)="setRange('container3','1M')">1M</button>
    <button (click)="setRange('container3','3M')">3M</button>
    <button (click)="setRange('container3','6M')">6M</button>
    <button (click)="setRange('container3','1Y')">1A</button>
    <button (click)="setRange('container3','all')">Todo</button>
  </div>
  <div id="container3" class="rend-chart"></div>
</div>

<div class="rend-wrapper" *ngIf="isBroker">
  <div class="rend-range-btns">
    <button (click)="setRange('container4','1M')">1M</button>
    <button (click)="setRange('container4','3M')">3M</button>
    <button (click)="setRange('container4','6M')">6M</button>
    <button (click)="setRange('container4','1Y')">1A</button>
    <button (click)="setRange('container4','all')">Todo</button>
  </div>
  <div id="container4" class="rend-chart"></div>
</div>

